import React from 'react';

import { GlobalFormContact } from 'src/modules/global';

export interface GlobalFormSalesforceProps {
  title: string;
  fullWidth?: boolean;
  buttonText?: string;
  isOpen?: boolean;
  onClose?: () => void;
  topJsx?: any;
  additionalFormFields?: Record<string, string>;
}

const GlobalFormSalesforce: React.FunctionComponent<GlobalFormSalesforceProps> = ({
  title,
  buttonText,
  fullWidth = true,
  topJsx = null,
  additionalFormFields = {},
}: GlobalFormSalesforceProps) => {
  const data = {
    oid: '00D3X000002KGzs',
    '00N3X00000Lx0Xn': 'Unknown',
    lead_source: 'Website',
    recordType: '0123X000001A3q3QAC',
    retURL: (typeof window !== 'undefined' && window.location.href) || 'http://walterknoll.de',
  };
  return (
    <GlobalFormContact
      data={data}
      url={process.env.NEXT_PUBLIC_SALESFORCE_FORM_URL}
      title={title}
      buttonText={buttonText}
      fullWidth={fullWidth}
      topJsx={topJsx}
      additionalFormFields={additionalFormFields}
    />
  );
};

export default GlobalFormSalesforce;
